import { proxy, useSnapshot } from 'valtio';
import { O } from '../lib/EffectExports';
const secureFormPopupStore = proxy({
    url: O.none(),
    invitationId: '',
    from: '',
    title: '',
    closeCallback: () => { },
    setError: () => { },
});
const setSecureFormPopupInfo = (url, invitationId, from, title, closeCallback, setError) => {
    secureFormPopupStore.url = O.some(url);
    secureFormPopupStore.invitationId = invitationId;
    secureFormPopupStore.from = from;
    secureFormPopupStore.title = title;
    secureFormPopupStore.closeCallback = closeCallback;
    secureFormPopupStore.setError = setError;
};
const closePopupInfo = () => {
    secureFormPopupStore.url = O.none();
    secureFormPopupStore.invitationId = '';
    secureFormPopupStore.from = '';
    secureFormPopupStore.title = '';
    secureFormPopupStore.closeCallback();
};
const clearSecureFormPopupInfo = () => {
    secureFormPopupStore.url = O.none();
    secureFormPopupStore.invitationId = '';
    secureFormPopupStore.from = '';
    secureFormPopupStore.title = '';
    secureFormPopupStore.setError();
};
export const useSecureFormPopupStore = () => {
    const snapshot = useSnapshot(secureFormPopupStore);
    return {
        url: snapshot.url,
        invitationId: snapshot.invitationId,
        from: snapshot.from,
        title: snapshot.title,
        setSecureFormPopupInfo,
        clearSecureFormPopupInfo,
        closePopupInfo,
    };
};
//# sourceMappingURL=secureFormPopupStore.js.map